import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TResetSeoUrls, EResetSeoUrlsActionType } from './types';

export const resetSeoUrls: () => TResetSeoUrls = actionGenerator<EResetSeoUrlsActionType.Reset>(
  EResetSeoUrlsActionType.Reset,
);
